import { useSelector } from "react-redux";

import messages from "../../../../../../assets/locale/messages";
import {
  BuildingSmallIcon,
  BriefCaseSmallIcon,
  LocationSmallIcon
} from "../../../../../../utils/Icons";

const CompanyInfoSection = () => {
  const lang = useSelector((state) => state.locale.lang);
  const { businessVerification } = messages[lang];

  const requestDetails = useSelector(
    (state) => state.businessVerification.verificationRequestMainInfo
  );

  const renderCompanyInfo = (icon, label, value) => (
    <div className="col-12 col-md-6 mb-4">
      <div className="d-flex align-items-center">
        <div className="me-4">{icon}</div>
        <div>
          <p className="mb-1 text-light-grey fsize-13">{label}</p>
          <p className="mb-0 text-color fsize-15 fweight-600 word-break">
            {value || "--"}
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="company-info-section">
      <h6 className="title-color fsize-16 fweight-600 mb-4">
        {
          businessVerification.requestDetails.companySection
            .companyInfo
        }
        :
      </h6>
      <div className="row border-bottom m-0 pb-2">
        {renderCompanyInfo(
          <BuildingSmallIcon />,
          businessVerification.requestDetails.companySection
            .companyName,
          requestDetails?.CompanyName
        )}
        {renderCompanyInfo(
          <BriefCaseSmallIcon />,
          businessVerification.requestDetails.companySection
            .businessType,
          requestDetails?.BusinessTypeName
        )}
        {renderCompanyInfo(
          <LocationSmallIcon />,
          businessVerification.requestDetails.companySection.country,
          requestDetails?.CountryName
        )}
      </div>
    </div>
  );
};

export default CompanyInfoSection;
